export default "__VITE_ASSET__8cb6e52e__"